import React from "react";
import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay, ease: easing }}
    >
        {children}
    </motion.div>
);

// Line-by-line masked reveal for headings. Pass an array of lines.
export const MaskReveal = ({ lines = [], className = "", delay = 0 }) => (
    <span className={className} aria-label={lines.join(" ")}>
        {lines.map((line, i) => (
            <span key={i} className="mask-line" aria-hidden="true">
                <motion.span
                    className="block"
                    initial={{ y: "110%" }}
                    animate={{ y: "0%" }}
                    transition={{
                        duration: 1.05,
                        delay: delay + i * 0.12,
                        ease: easing,
                    }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay, ease: easing }}
    >
        {children}
    </motion.div>
);
